import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaCheckCircle, FaEnvelope, FaRocket } from 'react-icons/fa';

const Welcome = () => {
    return (
        <Container className="py-5">
            <Row className="mb-5">
                <Col lg={8} className="mx-auto text-center">
                    <div className="mb-4">
                        <FaCheckCircle className="text-success" style={{ fontSize: '4rem' }} />
                    </div>
                    <h1 className="display-5 mb-4">Welcome to agenti.quest! 🎉</h1>
                    <p className="lead text-muted">
                        Your free trial has started! Check your email for your welcome message and first AI tools digest.
                    </p>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col md={4} className="mb-4">
                    <Card className="h-100 text-center border-success">
                        <Card.Body className="p-4">
                            <FaCheckCircle className="text-success mb-3" style={{ fontSize: '2rem' }} />
                            <Card.Title>Trial Active</Card.Title>
                            <Card.Text>
                                7-day free trial started<br />
                                Full access to all features<br />
                                No credit card required
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} className="mb-4">
                    <Card className="h-100 text-center border-info">
                        <Card.Body className="p-4">
                            <FaEnvelope className="text-info mb-3" style={{ fontSize: '2rem' }} />
                            <Card.Title>Check Your Email</Card.Title>
                            <Card.Text>
                                Welcome email sent<br />
                                First digest arriving soon<br />
                                Daily AI tools curated
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4} className="mb-4">
                    <Card className="h-100 text-center border-warning">
                        <Card.Body className="p-4">
                            <FaRocket className="text-warning mb-3" style={{ fontSize: '2rem' }} />
                            <Card.Title>What's Next?</Card.Title>
                            <Card.Text>
                                Explore AI tools<br />
                                Upgrade anytime<br />
                                Cancel no hassle
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row className="mb-5">
                <Col lg={8} className="mx-auto">
                    <Card className="border-0 shadow">
                        <Card.Body className="p-5 text-center">
                            <h3 className="mb-4">Your First AI Tools Are On Their Way!</h3>
                            <p className="text-muted mb-4">
                                We've curated 5 amazing AI tools for you today. You'll receive your first email digest within the next few minutes.
                            </p>
                            
                            <div className="mb-4">
                                <h5 className="mb-3">Today's Preview:</h5>
                                <div className="d-flex justify-content-center gap-3 flex-wrap">
                                    <span className="badge bg-primary p-2">AI Writing Assistant</span>
                                    <span className="badge bg-success p-2">Smart Calendar</span>
                                    <span className="badge bg-info p-2">Code Helper</span>
                                    <span className="badge bg-warning p-2">Design Tool</span>
                                    <span className="badge bg-secondary p-2">Productivity Bot</span>
                                </div>
                            </div>

                            <div className="d-flex gap-3 justify-content-center">
                                <Button variant="outline-secondary" href="/">
                                    Explore More Tools
                                </Button>
                                <Button variant="primary" href="/pricing">
                                    Upgrade to Pro
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col lg={8} className="mx-auto text-center">
                    <Card className="bg-light border-0">
                        <Card.Body className="p-4">
                            <h4 className="mb-3">Questions?</h4>
                            <p className="text-muted mb-4">
                                Need help getting started or have questions about your trial? We're here to help!
                            </p>
                            <div className="d-flex gap-3 justify-content-center">
                                <Button variant="outline-primary" href="mailto:support@funaiagent.com">
                                    Email Support
                                </Button>
                                <Button variant="outline-secondary" href="/pricing">
                                    View Pricing Plans
                                </Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Welcome;
